import type { InputActions, InputState } from "./types";

const LEFT_KEYS = new Set(["ArrowLeft", "a", "A"]);
const RIGHT_KEYS = new Set(["ArrowRight", "d", "D"]);
const ACCEL_KEYS = new Set(["ArrowUp", "w", "W"]);
const BRAKE_KEYS = new Set(["ArrowDown", "s", "S"]);

export class InputController {
  readonly state: InputState = {
    left: false,
    right: false,
    accelerate: false,
    brake: false,
    boost: false,
    pause: false,
    start: false,
    restart: false
  };

  private laneDelta: -1 | 0 | 1 = 0;
  private boostPressed = false;
  private pausePressed = false;
  private startPressed = false;
  private restartPressed = false;

  constructor() {
    window.addEventListener("keydown", this.handleKeyDown);
    window.addEventListener("keyup", this.handleKeyUp);
  }

  destroy(): void {
    window.removeEventListener("keydown", this.handleKeyDown);
    window.removeEventListener("keyup", this.handleKeyUp);
  }

  consumeActions(): InputActions {
    const actions: InputActions = {
      laneDelta: this.laneDelta,
      boost: this.boostPressed,
      pause: this.pausePressed,
      start: this.startPressed,
      restart: this.restartPressed
    };

    this.laneDelta = 0;
    this.boostPressed = false;
    this.pausePressed = false;
    this.startPressed = false;
    this.restartPressed = false;

    return actions;
  }

  private handleKeyDown = (event: KeyboardEvent): void => {
    if (LEFT_KEYS.has(event.key)) {
      this.state.left = true;
      if (!event.repeat) this.laneDelta = -1;
      event.preventDefault();
    } else if (RIGHT_KEYS.has(event.key)) {
      this.state.right = true;
      if (!event.repeat) this.laneDelta = 1;
      event.preventDefault();
    } else if (ACCEL_KEYS.has(event.key)) {
      this.state.accelerate = true;
      event.preventDefault();
    } else if (BRAKE_KEYS.has(event.key)) {
      this.state.brake = true;
      event.preventDefault();
    } else if (event.code === "Space") {
      this.state.boost = true;
      if (!event.repeat) this.boostPressed = true;
      event.preventDefault();
    } else if (event.key === "p" || event.key === "P" || event.key === "Escape") {
      this.state.pause = true;
      if (!event.repeat) this.pausePressed = true;
      event.preventDefault();
    } else if (event.key === "Enter") {
      this.state.start = true;
      this.state.restart = true;
      if (!event.repeat) {
        this.startPressed = true;
        this.restartPressed = true;
      }
      event.preventDefault();
    }
  };

  private handleKeyUp = (event: KeyboardEvent): void => {
    if (LEFT_KEYS.has(event.key)) {
      this.state.left = false;
    } else if (RIGHT_KEYS.has(event.key)) {
      this.state.right = false;
    } else if (ACCEL_KEYS.has(event.key)) {
      this.state.accelerate = false;
    } else if (BRAKE_KEYS.has(event.key)) {
      this.state.brake = false;
    } else if (event.code === "Space") {
      this.state.boost = false;
    } else if (event.key === "p" || event.key === "P" || event.key === "Escape") {
      this.state.pause = false;
    } else if (event.key === "Enter") {
      this.state.start = false;
      this.state.restart = false;
    }
  };
}
